import { de, es, ru, el } from 'date-fns/locale';

export default {
    de,
    el,
    en: null,
    es,
    ru,
};
